"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _css = require("@emotion/css");
var _spacing = require("@amzn/meridian-tokens/base/spacing");
var _text = _interopRequireDefault(require("./../_styles/text"));
var styles = function styles(t) {
  return (0, _css.css)((0, _text["default"])(t), {
    outline: "none",
    // Shared option and group header styles
    "& [mdn-option-list-item], & [role=presentation]": {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      width: "100%",
      boxSizing: "border-box"
    },
    // Option styles
    "& [mdn-option-list-item]": {
      padding: "".concat(t("optionSpacingInsetVertical"), "px ").concat(t("optionSpacingInsetHorizontal"), "px"),
      transition: t.transitionCss("optionMotion", ["color", "background-color"]),
      // Foreground and background color
      backgroundColor: t("optionBackgroundColorDefault"),
      color: t("optionForegroundColorDefault"),
      // Set color of child <Text/> components
      "& p": {
        color: t("optionForegroundColorDefault")
      },
      "&[aria-selected=true]": {
        backgroundColor: t("optionBackgroundColorSelected"),
        color: t("optionForegroundColorSelected"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorSelected")
        }
      },
      "&[aria-current=true], &:focus": {
        backgroundColor: t("optionBackgroundColorPreselected"),
        color: t("optionForegroundColorPreselected"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorPreselected")
        }
      },
      "&:active": {
        backgroundColor: t("optionBackgroundColorPressed"),
        color: t("optionForegroundColorPressed"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorPressed")
        }
      },
      "&[disabled], &[aria-disabled=true]": {
        backgroundColor: t("optionBackgroundColorDisabledDefault"),
        color: t("optionForegroundColorDisabledDefault"),
        cursor: "not-allowed",
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorDisabledDefault")
        }
      },
      "& > [mdn-option-list-item-child-wrapper]": {
        flex: 1
      }
    },
    // Menu item styles
    "& [role=menuitem]": {
      "&[disabled], &[aria-disabled=true]": {
        // Foreground and background color for [disabled, hover/focus]
        "&:hover, &:focus": {
          backgroundColor: t("optionBackgroundColorDisabledFocus"),
          color: t("optionForegroundColorDisabledFocus"),
          cursor: "not-allowed"
        }
      },
      // Prefix icon styles
      "span:has(span > svg)": {
        marginInlineEnd: _spacing.spacing300,
        flexShrink: 0
      }
    },
    // Group header styles
    "& [role=presentation]": {
      padding: "".concat(t("groupHeaderSpacingInsetVertical"), "px ").concat(t("groupHeaderSpacingInsetHorizontal"), "px"),
      // Foreground and background color
      backgroundColor: t("groupHeaderBackgroundColorDefault"),
      color: t("groupHeaderForegroundColorDefault"),
      fontWeight: t("groupHeaderFontWeight"),
      "&[disabled], &[aria-disabled]": {
        backgroundColor: t("groupHeaderBackgroundColorDisabled"),
        color: t("groupHeaderForegroundColorDisabled")
      }
    },
    // Group styles
    "& [role=group]": {
      borderBottom: t.borderCss("groupBorder")
    },
    // Selected indicator styles
    "&[aria-multiselectable=true] [mdn-option-list-item]": {
      "& > *:first-child": {
        flex: 1
      },
      "& > *:last-child": {
        flexShrink: 0,
        marginInlineStart: t("optionSpacingInsetHorizontal"),
        color: t("optionIndicatorColorDefault"),
        transition: t.transitionCss("motion", "color")
      },
      "&[aria-current=true] > *:last-child": {
        color: t("optionIndicatorColorPreselected")
      },
      "&[aria-selected=true] > *:last-child": {
        color: t("optionIndicatorColorSelected")
      },
      "&:active > *:last-child": {
        color: t("optionIndicatorColorPressed")
      },
      "&[disabled] > *:last-child, &[aria-disabled] > *:last-child": {
        color: "transparent"
      },
      "&[disabled][aria-selected=true] > *:last-child, &[aria-disabled][aria-selected=true] > *:last-child": {
        color: t("optionIndicatorColorDisabled")
      }
    }
  });
};
var _default = styles;
exports["default"] = _default;